import React, { useEffect, useCallback } from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';

export default function Menu(
  {
    menu,
    menuSettings,
    results,
    additionalData,
  }: componentTypes.MenuProps,
) {
  const id = encodeURIComponent(`white-instant-search-menu--${menuSettings.attribute}`)
    .toLowerCase()
    .replace(/\.|%[0-9a-z]{2}/gi, '');

  const goToUrl = useCallback((event: Event) => {
    event.preventDefault();
    event.stopPropagation();
    const target = event.currentTarget;
    if (target && target instanceof HTMLAnchorElement && target.href) {
      window.location.href = target.href;
    }
    return false;
  }, []);

  useEffect(() => {
    if (menuSettings.hardRefresh) {
      Array
        .from(document.querySelectorAll(`#${id} .nav-link`))
        .forEach((link) => {
          if (link instanceof HTMLAnchorElement) {
            // eslint-disable-next-line no-param-reassign
            link.onclick = goToUrl;
          }
        });
    }
  }, [id, menuSettings.hardRefresh, goToUrl, menu.items]);

  const {
    items,
    refine,
    canToggleShowMore,
    toggleShowMore,
    isShowingMore,
    createURL,
  } = menu;

  const {
    classNames,
    showMore,
    translations,
  } = menuSettings;

  let totalCount = 0;
  let isRefined = false;
  Object.values(items).forEach((item) => {
    // @ts-ignore
    totalCount += item.count;
    if (item.isRefined) isRefined = true;
  });

  // eslint-disable-next-line no-underscore-dangle
  if (results.__isArtificial) {
    return null;
  }

  return (
    <>
      <ul className={`ais-Menu-list ${classNames?.list || ''}`} id={id}>
        <li className={`ais-Menu-item ${classNames?.item || ''}`}>
          <a
            href={`${additionalData.baseUrl}${results.query && `?query=${results.query}`}`}
            className={`ais-Menu-link ${classNames?.link || ''} ${!isRefined && `ais-Menu-item--selected ${classNames?.selectedItem || ''}`}`}
          >
            <span className={`ais-Menu-label ${classNames?.label}`}>{Craft.t('search', 'Show all')}</span>
            <span className={`ais-Menu-count ${classNames?.count}`}>{totalCount}</span>
          </a>
        </li>
        {items.map((item) => (
          <li
            key={item.value}
            className={`ais-Menu-item ${classNames?.item || ''}`}
          >
            <a
              className={`ais-Menu-link ${classNames?.link || ''} ${item.isRefined && `ais-Menu-item--selected ${classNames?.selectedItem || ''}`}`}
              href={createURL(item.value)}
              onClick={(event) => {
                event.preventDefault();
                refine(item.value);
              }}
            >
              <span className={`ais-Menu-label ${classNames?.label || ''}`}>
                {item.label}
              </span>
              <span className={`ais-Menu-count ${classNames?.count || ''}`}>
                {item.count}
              </span>
            </a>
          </li>
        ))}
      </ul>
      {showMore && (
        <button
          className={`ais-RefinementList-showMore ${classNames?.showMore || ''} ${canToggleShowMore ? '' : (`ais-RefinementList-showMore--disabled ${classNames?.disabledShowMore || ''}`)}`}
          disabled={!canToggleShowMore}
          type="button"
          onClick={toggleShowMore}
        >
          {translations?.showMoreButtonText
            ? (translations?.showMoreButtonText({ isShowingMore }))
            : 'show more'}
        </button>
      )}
    </>

  );
}
